import { jsx as _jsx } from "react/jsx-runtime";
import { getInProgressItem, getInProgressItemCount, orderHasMaximumAllowedQuantityOfItemPrice, updateInProgressItemQuantity } from '@vista/omnichannel-components-domain';
import { ItemType } from '@vista-digital/ocapi-types/v1';
import { observer } from 'mobx-react';
import { useCallback } from 'react';
import { useOccDisplayText } from '../../../context/occ/hooks/use-occ-display-text';
import { handleItemQuantityChanged } from '../../../utils/items/handle-item-quantity-changed';
import { NumberInput } from '../../form/input/number/number-input';
export const ItemModalQuantityInput = observer(props => {
    const { order: orderDisplayText } = useOccDisplayText();
    const { className, sellableItem, itemPrice, min, allowedMaximumForPriceRestrictedItem, isEditViewActive, quantityInputType } = props;
    const inProgressItemCount = getInProgressItemCount();
    const max = allowedMaximumForPriceRestrictedItem || props.max;
    const handleInProgressItemUpdate = useCallback((newQuantity) => {
        updateInProgressItemQuantity(sellableItem, newQuantity, itemPrice);
        const isMaxReached = newQuantity === props.max;
        const isMaxAllowedReachedForDiscountedItem = isMaximumAllowedSelectionReachedForDiscountedPrice(sellableItem, isEditViewActive);
        handleItemQuantityChanged(isMaxReached, isMaxAllowedReachedForDiscountedItem, orderDisplayText);
    }, [props.max, isEditViewActive, sellableItem, itemPrice, orderDisplayText]);
    if (inProgressItemCount < min)
        return null;
    return (_jsx(NumberInput, { className: className, value: inProgressItemCount, type: quantityInputType, min: min, max: max, disabled: max === 0, onChangeValue: handleInProgressItemUpdate }));
});
ItemModalQuantityInput.displayName = 'ItemModalQuantityInput';
const isMaximumAllowedSelectionReachedForDiscountedPrice = (sellableItem, isEditViewActive) => {
    const inProgressItem = getInProgressItem();
    if ((inProgressItem === null || inProgressItem === void 0 ? void 0 : inProgressItem.type) !== ItemType.Normal)
        return false; // This function is only called for in-progress normal items
    return orderHasMaximumAllowedQuantityOfItemPrice(sellableItem.itemId, inProgressItem.selectedPrice, getInProgressItemCount(), isEditViewActive);
};
